import './App.css';
import React from 'react';
import checklistData from './checklistdata.ts';

class ChecklistItem extends React.Component<{text: string, num: number, date: string, time?: string, eventId: string, sectionNum: number}, {checked: boolean, publishDate: Date}> {
  constructor(props: {text: string, num: number, date: string, time?: string, eventId: string, sectionNum: number}) {
    super(props);
    this.state = {
        checked: localStorage.getItem(`checklist-${props.eventId}-${props.sectionNum}-${props.num}`) === 'true',
        publishDate: new Date(Date.UTC(parseInt(props.date.split('-')[0]), parseInt(props.date.split('-')[1]) - 1, parseInt(props.date.split('-')[2]), props.time ? parseInt(props.time.split(':')[0]) : 8, props.time ? parseInt(props.time.split(':')[1]) : 0))
    };
    console.log(this.state.publishDate)
  }

  toggleState = () => {
    let isHidden: boolean = this.state.publishDate > new Date();
    if (isHidden) {return;}
    this.setState({ checked: !this.state.checked });
    localStorage.setItem(`checklist-${this.props.eventId}-${this.props.sectionNum}-${this.props.num}`, JSON.stringify(!this.state.checked));
  }

  render(): React.ReactNode {
    let isHidden: boolean = new Date(this.state.publishDate) > new Date();
    console.log(this.state.publishDate, new Date(), isHidden)
    return (
      <div className={"checklist-item noselect" + (isHidden ? " hidden" : " unhidden") + (this.state.checked ? " checked" : "")} onClick={this.toggleState}>
        {this.state.checked && <span className="checkmark">✔</span>}
        <div className="checklist-text-container">
          <div className="checklist-text">#{this.props.num}</div>
          <div className="checklist-text">{isHidden ? '?' : this.props.text}</div>
        </div>
      </div>
    );
  }
}

interface ChecklistState {
    sections: {title: string, items: {name: string, publishDate: string, publishTime?: string}[]}[];
    eventName: string;
    eventShortName: string;
    closingDate: string;
}

class Checklist extends React.Component<{}, ChecklistState> {
  constructor(props: {}) {
    super(props);
    this.state = checklistData;
  }

  render(): React.ReactNode {
    let num = 0;
    return <div className="checklist"><h1>{this.state.eventName}</h1><h1>Tracker</h1><p style={{ marginBottom: '0' }}>Tap/Click to tick</p>{
        this.state.sections.map((section, sectionIndex) => (
        <>
            <h2>{section.title}</h2>
            <div className='checklist-container'>
                {section.items.map((item, itemIndex) => (
                    <ChecklistItem key={itemIndex} text={item.name} sectionNum={sectionIndex+1} num={itemIndex + 1} date={item.publishDate} time={item.publishTime} eventId={this.state.eventShortName} />
                ))}
            </div>
        </>
    ))
    }<p>Closing Date: {this.state.closingDate}</p><a className="button-link" href="/">Homepage</a></div>
  }

}

export type {ChecklistState};
export default Checklist;
